import { NavbarLink } from '../components/Hero/Navbar/Navbar';
import externalLinks from '../utils/externalLinks';

export const defaultNavbarLinks: NavbarLink[] = [
  {
    href: externalLinks.onlineshop,
    text: 'onlineshop',
    type: 'text',
  },
  {
    href: externalLinks.karriere,
    text: 'karriere',
    type: 'text',
  },
  {
    alt: 'HSE Logo',
    href: '/',
    src: require('assets/images/outline-logo.svg'),
    target: '_self',
    type: 'image',
  },
  {
    href: externalLinks.investor,
    text: 'Investor Relations',
    type: 'text',
    toggle: [
      {
        name: 'Fact Sheet',
        link: 'fact-sheet',
      },
      {
        name: 'Bond',
        link: 'bond',
      },
      {
        name: 'Publications',
        link: 'publications',
      },
      {
        name: 'Financial Calendar',
        link: 'financial-calendar',
      },
      {
        name: 'Rating',
        link: 'rating',
      },
    ],
  },
  {
    href: externalLinks.contact,
    text: 'KONTAKT',
    type: 'text',
  },
];

export const defaultFooterLinks = [];

export const factSheet2024 = [
  { label: 'Revenue', value: '642m€' },
  { label: 'Adjusted EBITDA', value: '94m€' },
  { label: 'Adjusted EBITDA as reported*', value: '93m€' },
  {
    label: 'Products',
    value:
      '  The range comprises products from the fields of fashion, jewellery, beauty, wellness, household, and home & living.',
  },
  { label: 'TV-stations', value: '3 in DACH' },
  { label: 'Reach', value: '45m TV households in DACH' },
];

export const FinancialCalendar2022 = [
  {
    date: '30th May 2023',
    hour: '3 p.m. CET',
    labels: [
      'Publication of 3M 2023 Financial Reporting',
      'Publication of Q1 2023 Investor Presentation',
    ],
  },
  { date: '5th June 2023', hour: '11 a.m. CET', labels: ['Investor Call: Q1 2023 results'] },
  {
    date: '29th August 2023',
    hour: '3 p.m. CET',
    labels: [
      'Publication of 6M 2023 Financial Reporting',
      'Publication of Q2 2023 Investor Presentation',
    ],
  },
  { date: '7th September 2023', hour: '3 p.m. CET', labels: ['Investor Call: Q2 2023 results'] },
  {
    date: '28th November 2023',
    hour: '3 p.m. CET',
    labels: [
      'Publication of 9M 2023 Financial Reporting',
      'Publication of Q3 2023 Investor Presentation',
    ],
  },
  { date: '7th December 2023', hour: '3 p.m. CET', labels: ['Investor Call: Q3 2023 results'] },
  {
    date: '29th April 2024',
    hour: '3 p.m. CET',
    labels: [
      'Publication of FY 2023 Financial Reporting',
      'Publication of FY 2023 Investor Presentation',
    ],
  },
  { date: '7th May 2024', hour: '3 p.m. CET', labels: ['Investor Call: FY 2023 results'] },
];

export const FinancialCalendar2024 = [
  {
    date: '29th April 2024',
    hour: '3 p.m. CET',
    labels: [
      'Publication of FY 2023 Financial Reporting',
      'Publication of FY 2023 Investor Presentation',
    ],
  },
  { date: '7th May 2024', hour: '3 p.m. CET', labels: ['Investor Call: FY 2023 results'] },
  {
    date: '29th May 2024',
    hour: '3 p.m. CET',
    labels: [
      'Publication of 3M 2024 Financial Reporting',
      'Publication of Q1 2024 Investor Presentation',
    ],
  },
  { date: '6th June 2024', hour: '3 p.m. CET', labels: ['Investor Call: Q1 2024 results'] },
  {
    date: '29th August 2024',
    hour: '3 p.m. CET',
    labels: [
      'Publication of 6M 2024 Financial Reporting',
      'Publication of Q2 2024 Investor Presentation',
    ],
  },
  { date: '5th September 2024', hour: '3 p.m. CET', labels: ['Investor Call: Q2 2024 results'] },
  {
    date: '29th November 2024',
    hour: '3 p.m. CET',
    labels: [
      'Publication of 9M 2024 Financial Reporting',
      'Publication of Q3 2024 Investor Presentation',
    ],
  },
  { date: '9th December 2024', hour: '3 p.m. CET', labels: ['Investor Call: Q3 2024 results'] },
  {
    date: '30th April 2025',
    hour: '3 p.m. CET',
    labels: [
      'Publication of FY 2024 Financial Reporting',
      'Publication of FY 2024 Investor Presentation',
    ],
  },
  { date: '7th May 2025', hour: '3 p.m. CET', labels: ['Investor Call: FY 2024 results'] },
];

export const FinancialCalendar2025 = [
  {
    date: '29th August 2025',
    hour: '3 p.m. CEST',
    labels: [
      'Publication of Q2 2025 Financial Reporting',
      'Publication of Q2 2025 Investor Presentation',
    ],
  },
  {
    date: '10th September 2025',
    hour: '3 p.m. CEST',
    labels: [
      'Investor Call: Q2 2025 Results',
    ],
  },
  {
    date: '1st December 2025',
    hour: '3 p.m. CEST',
    labels: [
      'Publication of Q3 2025 Financial Reporting',
      'Publication of Q3 2025 Investor Presentation',
    ],
  },
  { date: '8th December 2025', hour: '3 p.m. CEST', labels: ['Investor Call: Q3 2025 Results'] },
];

export const FinancialCalendar2026 = [
  {
    date: '30 April 2026',
    hour: '3 pm CEST',
    labels: [
      'Publication of FY 2025 Financial Reporting',
      'Publication of FY 2025 Investor Presentation',
    ],
  },
  {
    date: '7 May 2026',
    hour: '3 pm CEST',
    labels: [
      'Investor Call: FY 2025 Results',
    ],
  },
  {
    date: '29 May 2026',
    hour: '3 pm CEST',
    labels: [
      'Publication of Q1 2026 Financial Reporting',
      'Publication of Q1 2026 Investor Presentation',
    ],
  },
  { date: '2 June 2026', hour: '10 am CEST', labels: ['Investor Call: Q1 2026 Results'] },
  {
    date: '28 August 2026',
    hour: '3 pm CEST',
    labels: [
      'Publication of Q2 2026 Financial Reporting',
      'Publication of Q2 2026 Investor Presentation',
    ]
  },
  {
    date: '10 September 2026',
    hour: '11 am CEST',
    labels: [
      'Investor Call: Q2 2026 Results',
    ],
  },
  {
    date: '27 November 2026',
    hour: '3 pm CET',
    labels: [
      'Publication of Q3 2026 Financial Reporting',
      'Publication of Q3 2026 Investor Presentation',
    ]
  },
  {
    date: '10 December 2026',
    hour: '11 am CET',
    labels: [
      'Investor Call: Q3 2026 Results',
    ],
  },
];

export const PUBS2026 = [
  {
    date: 'Q3 2026',
    pub: 'Notice of Satisfaction of Condition for Full Redemption',
    file: require('assets/documents/Q3_2026/20260824_Notice_Full_Redemption_FINAL.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Rating Report S&P Global Ratings',
    file: require('assets/documents/Q3_2026/20260821_S&P_Rating_Report_B-_published.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Rating Report Fitch Ratings',
    file: require('assets/documents/Q3_2026/20260818_Fitch_Rating_Report_B-_published.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Results of the Exchange Offer and Consent Solicitation',
    file: require('assets/documents/Q3_2026/20260812_Results_ExOffer_ConsSolicitation.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Pricing Press Release',
    file: require('assets/documents/Q3_2026/20260812_Press_Release_Pricing.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Supplement to the Exchange Offer and Consent Solicitation',
    file: require('assets/documents/Q3_2026/HSE_Supplement_2_to_EOM.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Extension of the Exchange Offer and Consent Solicitation',
    file: require('assets/documents/Q3_2026/20260807_ Extension_Expiration_Date.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Supplement to the Exchange Offer and Consent Solicitation',
    file: require('assets/documents/Q3_2026/HSE_Supplement_to_EOM_FINAL.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Extension of the Exchange Offer and Consent Solicitation',
    file: require('assets/documents/Q3_2026/HSE_Announcement_Extension_Expiration_Date_to_August_4.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Announcement of Amendment to the Exchange Offer and Consent Solicitation',
    file: require('assets/documents/Q3_2026/HSE_Exchange_Announcement_Extension_to_July_31.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Announcement Refinancing Transaction',
    file: require('assets/documents/Q3_2026/HSE_Announcement_Refinancing_Transaction.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'Company Presentation',
    file: require('assets/documents/Q3_2026/HSE_Company_Presentation_July_2026.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: 'FY 2025 Financial Pages (Audited)',
    file: require('assets/documents/FY_2025/Updated_FY_2025_Financial_Pages_HSE_Investment_sarl_audited.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2026',
    pub: '3M 2026 Financial Pages',
    file: require('assets/documents/Q3_2026/Updated_3M_2026_Financial_Pages_HSE_Investment_sarl_002.pdf'),
    divider: true,
    spacing: true,
  },
  
  
  {
    date: 'Q2 2026',
    pub: 'Q2 2026 Investor Call (Dial-in information)',
    file: require('assets/documents/Q2_2026/20260827_Investor_Call_Dial-in_Information.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2026',
    pub: 'Q2 2026 Announcement Financial Results',
    file: require('assets/documents/Q2_2026/20260827_Q2_2026_Announcement_Financial_Results_final.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2026',
    pub: 'Q2 2026 Investor Presentation',
    file: require('assets/documents/Q2_2026/20260827_HSE_Q22026_Investor_Presentation_final.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2026',
    pub: 'Q2 2026 Financial reporting',
    file: require('assets/documents/Q2_2026/260826_6M 2026_Financial Reporting_HSE Investment Sarl.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2026',
    pub: 'Q2 2026 Material Differences Report',
    file: require('assets/documents/Q2_2026/260824_HSE - Material Differences Report_30.6.26.pdf'),
    divider: true,
    spacing: true,
  },


  {
    date: 'Q2 2026',
    pub: 'Rating Report S&P Global Ratings',
    file: require('assets/documents/Q2_2026/20260624_S_P_Rating_Report_B-_stable.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2026',
    pub: 'Rating Report Fitch Ratings',
    file: require('assets/documents/Q2_2026/20260616_Fitch_Rating_Report_B-_Outlook_Positive.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2026',
    pub: 'Q1 2026 Investor Call (Dial-in Information)',
    file: require('assets/documents/Q1_2026/20260521_Investor_Call_(Dial-in_Information)_final.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2026',
    pub: 'Q1 2026 Material Differences Report',
    file: require('assets/documents/Q1_2026/Q1_2026_Material_Differences_Report.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2026',
    pub: 'Announcement - Quarterly Cash Sweep Redemption',
    file: require('assets/documents/Q1_2026/20260505_Announce_CashSweep_Q1_2026_final.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2026',
    pub: 'Announcement - Voluntary Cash Sweep',
    file: require('assets/documents/Q1_2026/20261207_HSE_Early_Redemption_final_16.13.pdf'),
    divider: true,
    spacing: true,
  },
];

export const PUBS2025 = [
  {
    date: 'FY 2025',
    pub: 'FY 2025 Investor Call (Dial-in Information)',
    file: require('assets/documents/FY_2025/20260428_Investor_Call_(Dial-in_Information).pdf'),
    divider: true,
  },
  {
    date: 'FY 2025',
    pub: 'FY 2025 Material Differences Report',
    file: require('assets/documents/FY_2025/20260423_HSE_Mat_Diff_Report_YE2025.pdf'),
    divider: true,
    spacing: true,
  },

  {
    date: 'Q4 2025',
    pub: '2024 ESG Report',
    file: require('assets/documents/Q4_2025/HSE_ESG_Report2024.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q3 2025',
    pub: 'Q3 2025 Investor Call (Dial-in information)',
    file: require('assets/documents/Q3_2025/Q3_2025_Investor_call_(Dial-in information).pdf'),
    divider: true,
  },
  {
    date: 'Q3 2025',
    pub: 'Q3 2025 Announcement Financial Results',
    file: require('assets/documents/Q3_2025/Q3_2025_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2025',
    pub: 'Q3 2025 Investor Presentation',
    file: require('assets/documents/Q3_2025/Q3_2025_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2025',
    pub: '9M 2025 Financial Reporting',
    file: require('assets/documents/Q3_2025/9M_2025_Financial_Reporting_HSE_Investment_Sarl.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2025',
    pub: 'Q3 2025 Material Differences Report',
    file: require('assets/documents/Q3_2025/Q3_2025_Material_Differences_Report.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2025',
    pub: 'Q2 2025 Investor Call (Dial-in information)',
    file: require('assets/documents/Q2_2025/Q2_2025_Investor_call_(Dial_in_Information).pdf'),
    divider: true,
  },
  {
    date: 'Q2 2025',
    pub: 'Q2 2025 Announcement Financial Results',
    file: require('assets/documents/Q2_2025/Q2_2025_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2025',
    pub: 'Q2 2025 Investor Presentation',
    file: require('assets/documents/Q2_2025/Q2_2025_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2025',
    pub: '6M 2025 Financial Reporting',
    file: require('assets/documents/Q2_2025/6M_2025_Financial_Reporting.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2025',
    pub: 'Announcement - Deleveraging Transaction',
    file: require('assets/documents/Q2_2025/20250703_HSE_Closing_Announcement_final.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2025',
    pub: 'Press Release Receipt of Required Consents concerning Solicitation',
    file: require('assets/documents/Q2_2025/20250415_Press_Release_Receipt_Consent_Solicitation_v2.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2025',
    pub: 'Press Release Consent Solicitation',
    file: require('assets/documents/Q2_2025/20250407_Press_Release_Consent_Solicitation.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2025',
    pub: ' Q1 2025 Investor call (Dial-in information)',
    file: require('assets/documents/Q1_2025/250526_Q1-2025_Investor_Call_Dial_in_information.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2025',
    pub: ' Q1 2025 Announcement Financial Results',
    file: require('assets/documents/Q1_2025/250526_Q1-2025_Announcement_Financial_Reporting.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2025',
    pub: 'Q1 2025 Investor Presentation',
    file: require('assets/documents/Q1_2025/250530_Investor_Presentation_final.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2025',
    pub: '3M 2025 Financial Reporting',
    file: require('assets/documents/Q1_2025/250523_3M-2025_Financial_Reporting.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2025',
    pub: 'Announcement - Change in Management Board of HSE Finance S.à.r.l.',
    file: require('assets/documents/Q1_2025/20250407_HSE_Finance_S.à_r.l._Change_Mgmt_Alfonso.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2025',
    pub: 'Transaction Announcement',
    file: require('assets/documents/Q1_2025/20250328_HSE_Transaction_Announcement.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2025',
    pub: 'Investor Update',
    file: require('assets/documents/Q1_2025/20250328_Investor_Update.pdf'),
    divider: true,
    spacing: true,
  },
];

export const PUBS2024 = [
  {
    date: 'FY 2024',
    pub: 'FY2024 Investor Call (Dial-in information)',
    file: require('assets/documents/FY_2024/250429_12M_2024_Investor_call_Dial_in_information.pdf'),
    divider: true,
  },
  {
    date: 'FY 2024',
    pub: 'FY2024 Announcement Financial Results',
    file: require('assets/documents/FY_2024/250429_12M_2024_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'FY 2024',
    pub: 'FY2024 Investor Presentation',
    file: require('assets/documents/FY_2024/250503_Investor_Presentation_final_v2.pdf'),
    divider: true,
  },
  {
    date: 'FY 2024',
    pub: 'FY2024 Financial Reporting(Audit report)',
    file: require('assets/documents/FY_2024/250429_Financial_Result_Audit_Report.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q3 2024',
    pub: '2023 ESG Report',
    file: require('assets/documents/2024/HSE_ESG_Report_2023_engl.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2024',
    pub: 'Q3 2024 Investor call (Dial-in information)',
    file: require('assets/documents/2024/241129_9M_2024_Investor_call_(Dial_in_information).pdf'),
    divider: true,
  },
  {
    date: 'Q3 2024',
    pub: 'Q3 2024 Announcement Financial Results',
    file: require('assets/documents/2024/241129_9M_2024_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2024',
    pub: 'Q3 2024 Investor Presentation',
    file: require('assets/documents/2024/241202_9M_2024_Investor_Presentation_Final_v2.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2024',
    pub: 'Q3 2024 Financial Reporting ',
    file: require('assets/documents/2024/241129_9M_2024_Financial_Reporting_HSE_Finance_Sarl_FINAL.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q3 2024',
    pub: 'Announcement - Change in Management of HSE Finance S.à.r.l.',
    file: require('assets/documents/2024/20240917_Announcement_HSE_Finance_Sarl_Mgmt.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Q2 2024 Investor call (Dial-in information)',
    file: require('assets/documents/2024/6M_2024_Investor_call_Dial-in_information.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Q2 2024 Announcement Financial Results',
    file: require('assets/documents/2024/6M_2024_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Q2 2024 Investor Presentation',
    file: require('assets/documents/2024/6M_2024_Investor_Presentation_final_v2.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Q2 2024 Financial Reporting',
    file: require('assets/documents/2024/6M_2024_Financial_Reporting_HSE_Finance_Sarl.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Announcement - HSE exits its Russian activities',
    file: require('assets/documents/2024/20240618_Announcement_Russia.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Announcement - Change in the Management Board of Home Shopping Europe GmbH',
    file: require('assets/documents/2024/20240528_Announcement_Mgmt.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2024',
    pub: 'Announcement - Change in the Management Board of Home Shopping Europe GmbH',
    file: require('assets/documents/Q1_2024/240417_HSE_Change_in_management_Bond_signed.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2024',
    pub: 'Q1 2024 Investor call (Dial-in information)',
    file: require('assets/documents/2024/Q1_2024_Investor_call_Dial-in_information.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2024',
    pub: 'Q1 2024 Announcement Financial Results',
    file: require('assets/documents/2024/Q1_2024_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2024',
    pub: 'Q1 2024 Investor Presentation',
    file: require('assets/documents/2024/Q1_2024_Investor_Presentation_v2.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2024',
    pub: '3M 2024 Financial Reporting',
    file: require('assets/documents/2024/3M_2024_Financial_Reporting.pdf'),
    divider: true,
  },
];

export const PUBS2023 = [
  {
    date: 'FY 2023',
    pub: 'FY 2023 Investor call (Dial-in information)',
    file: require('assets/documents/FY_2023/FY_2023_Investor_call_Dial-in_information.pdf'),
    divider: true,
  },
  {
    date: 'FY 2023',
    pub: 'FY 2023 Announcement Financial Results',
    file: require('assets/documents/FY_2023/FY_2023_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'FY 2023',
    pub: 'FY 2023 Investor Presentation',
    file: require('assets/documents/FY_2023/FY_2023_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'FY 2023',
    pub: 'FY 2023 Financial Reporting (Audit report)',
    file: require('assets/documents/FY_2023/FY_2023_Financial_Reporting_Audit_Report.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q4 2023',
    pub: 'Announcement - Change in the Management Board of Home Shopping Europe GmbH',
    file: require('assets/documents/Q4_2023/20231219_Change_in_Management_HSE.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q3 2023',
    pub: 'Q3 2023 Investor call (Dial-in information)',
    file: require('assets/documents/Q3_2023/Q3_2023_Investor_call_Dial-in-information.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2023',
    pub: 'Q3 2023 Announcement Financial Results',
    file: require('assets/documents/Q3_2023/Q3_2023_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2023',
    pub: 'Q3 2023 Investor Presentation',
    file: require('assets/documents/Q3_2023/Q3_2023_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2023',
    pub: '9M 2023 Financial Reporting',
    file: require('assets/documents/Q3_2023/9M_2023_Financial_Reporting.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2023',
    pub: 'Announcement - New Board Member',
    file: require('assets/documents/Q3_2023/230921_HSE_Personalie_AndreaDeSantis_ENG_final.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2023',
    pub: 'Q2 2023 Investor Call (Dial-in information)',
    file: require('assets/documents/Q2_2023/Q2-2023_Investor_call_Dial-in_information.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2023',
    pub: 'Q2 2023 Announcement Financial Results',
    file: require('assets/documents/Q2_2023/Q2_2023_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2023',
    pub: 'Q2 2023 Investor Presentation',
    file: require('assets/documents/Q2_2023/Q2_2023_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2023',
    pub: '6M 2023 Financial Reporting',
    file: require('assets/documents/Q2_2023/6M_2023_Financial_Reporting.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2023',
    pub: '2022 ESG Report',
    file: require('assets/documents/Q2_2023/2022_ESG_REPORT_eng.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2023',
    pub: 'Q1 2023 Investor Call (Dial-in information)',
    file: require('assets/documents/Q1_2023/Q1_2023_Investor_call_Dial-in_information.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2023',
    pub: 'Q1 2023 Announcement Financial Results',
    file: require('assets/documents/Q1_2023/Q1_2023_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2023',
    pub: 'Q1 2023 Investor Presentation',
    file: require('assets/documents/Q1_2023/Q1_2023_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2023',
    pub: '3M 2023 Financial Reporting',
    file: require('assets/documents/Q1_2023/3M_2023_Financial_Reporting.pdf'),
    divider: true,
  },
];

export const PUBS2022 = [
  {
    date: 'FY 2022',
    pub: 'FY 2022 Investor call (Dial-in information)',
    file: require('assets/documents/FY_2022/FY_2022_Investor_call_Dial-in_information.pdf'),
    divider: true,
  },
  {
    date: 'FY 2022',
    pub: 'FY 2022 Announcement Financial Results',
    file: require('assets/documents/FY_2022/FY_2022_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'FY 2022',
    pub: 'FY 2022 Investor Presentation',
    file: require('assets/documents/FY_2022/FY_2022_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'FY 2022',
    pub: 'FY 2022 Financial Reporting (Audit report)',
    file: require('assets/documents/FY_2022/FY_2022_Financial_reporting_Audit_report.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q3 2022',
    pub: 'Q3 2022 Investor call (Dial-in information)',
    file: require('assets/documents/Q3_2022/Q3_2022_Investor_call_Dial-in-information.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2022',
    pub: 'Q3 2022 Announcement Financial Results',
    file: require('assets/documents/Q3_2022/Q3_2022_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2022',
    pub: 'Q3 2022 Investor Presentation',
    file: require('assets/documents/Q3_2022/Q3_2022_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q3 2022 ',
    pub: '9M 2022 Financial Reporting',
    file: require('assets/documents/Q3_2022/9M-2022-Financial-Reporting.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q2 2022',
    pub: 'Q2 2022 Investor call (Dial-in information)',
    file: require('assets/documents/Q2_2022/Q2_2022_Investor_call_Dial-in-information.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2022',
    pub: 'Q2 2022 Announcement Financial Results',
    file: require('assets/documents/Q2_2022/Q2_2022_Announcement_Financial_Results.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2022',
    pub: 'Q2 2022 Investor Presentation',
    file: require('assets/documents/Q2_2022/Q2_2022_Investor-Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q2 2022 ',
    pub: '6M 2022 Financial Reporting',
    file: require('assets/documents/Q2_2022/6M_2022_Financial_Reporting.pdf'),
    divider: true,
    spacing: true,
  },
  {
    date: 'Q1 2022',
    pub: 'Q1 2022 Investor Call (Dial-in information)',
    file: require('assets/documents/Q12022/Q1_2022_Investor_call.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2022',
    pub: 'Q1 2022 Announcement Financial Results',
    file: require('assets/documents/Q12022/Q1_2022_Announcement_Financial_Results.pdf'),
    divider: true,
  },

  {
    date: 'Q1 2022',
    pub: 'Q1 2022 Investor Presentation',
    file: require('assets/documents/Q12022/Q1_2022_Investor_Presentation.pdf'),
    divider: true,
  },
  {
    date: 'Q1 2022',
    pub: '3M 2022 Financial Reporting',
    file: require('assets/documents/Q12022/Q1_2022_3M _2022_Financial_Reporting.pdf'),
    divider: true,
  },
];
